import React from 'react';
import PropTypes from 'prop-types';
import Heading from '../Heading';
import {
  StyledHeader,
  StyledLabel,
  StyledMainHeading,
  StyledSubHeading
} from './Styles';
import isOmpPlatform from '../../utils/isOmpPlatform';

const propTypes = {
  mainHeading: PropTypes.string.isRequired,
  subHeading: PropTypes.string.isRequired,
  caption: PropTypes.string
};

const defaultProps = {
  caption: ''
};

const ListPageHeader = ({ mainHeading, subHeading, caption }) => {
  const isOmp = isOmpPlatform();

  return (
    <StyledHeader>
      <Heading>
        {!isOmp && (
          <>
            <StyledMainHeading data-testid="page-header-heading">
              {mainHeading}
              &nbsp; |&nbsp;
            </StyledMainHeading>
            <StyledSubHeading data-testid="page-header-subheading">
              {subHeading}
            </StyledSubHeading>
          </>
        )}

        {isOmp && (
          <>
            <StyledMainHeading data-testid="page-header-heading">
              {mainHeading}
            </StyledMainHeading>
            <StyledSubHeading data-testid="page-header-subheading">
              {subHeading}
            </StyledSubHeading>
          </>
        )}
      </Heading>
      <StyledLabel testId="page-header-caption">{caption}</StyledLabel>
    </StyledHeader>
  );
};

ListPageHeader.propTypes = propTypes;
ListPageHeader.defaultProps = defaultProps;

export default ListPageHeader;
